import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import WaitingIncomingCallRow from './WaitingIncomingCallRow';
import {
  CALL_UI_Z_INDEX,
  WAITING_CALLS_DROPDOWN_OFFSET_PX
} from '../../hooks/calls/callUiConstants';

const DROPDOWN_PANEL_STYLE = {
  position: 'fixed',
  width: 'min(320px, calc(100vw - 24px))',
  backgroundColor: '#fff',
  border: '1px solid #e5e7eb',
  borderRadius: 8,
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
  paddingTop: 8,
  paddingBottom: 8,
  zIndex: CALL_UI_Z_INDEX.headerWaitingDropdown
};

const WaitingCallsDropdown = memo(({
  isOpen,
  menuPosition,
  visibleCount,
  authorizedCalls,
  panelRef
}) => {
  const { t } = useTranslation('Fonema');

  if (!isOpen || visibleCount <= 0 || !menuPosition) {
    return null;
  }

  return createPortal(
    <div
      ref={panelRef}
      className="tw-wrapper"
      style={{
        ...DROPDOWN_PANEL_STYLE,
        top: menuPosition.top,
        right: menuPosition.right
      }}
      role="listbox"
      aria-label={t('waiting_incoming_calls_title', { count: visibleCount })}
    >
      <p
        style={{
          margin: 0,
          padding: '0 12px 8px',
          fontSize: 11,
          fontWeight: 600,
          textTransform: 'uppercase',
          color: '#6b7280'
        }}
      >
        {t('waiting_incoming_calls_title', { count: visibleCount })}
      </p>
      <ul
        style={{
          margin: 0,
          padding: 0,
          listStyle: 'none',
          maxHeight: 'min(360px, 50vh)',
          overflowY: 'auto'
        }}
      >
        {authorizedCalls.map((call) => (
          <WaitingIncomingCallRow key={call.callId} callInfoData={call} />
        ))}
      </ul>
    </div>,
    document.body
  );
});

WaitingCallsDropdown.displayName = 'WaitingCallsDropdown';

export { WAITING_CALLS_DROPDOWN_OFFSET_PX };
export default WaitingCallsDropdown;
